// extracted by mini-css-extract-plugin
export var category = "StandardPageHit-module--category--9cf95";
export var content = "StandardPageHit-module--content--3dff7";
export var description = "StandardPageHit-module--description--0ca7f";
export var fallbackImageContainer = "StandardPageHit-module--fallback-image-container--8fcdf";
export var image = "StandardPageHit-module--image--6e6c4";
export var row = "StandardPageHit-module--row--75fb1";
export var title = "StandardPageHit-module--title--8e20c";